module.exports = __webpack_public_path__ + "img/corporate_education.ce685e84.png";